import { useState, useEffect } from "react";
import LoadingComponent from "../components/LoadingComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../store/actions/categoryActions";
import { addPost, loadingSet as loadingSetPost } from "../store/actions/postActions";
import { loadingSet as loadingSetCategory } from "../store/actions/categoryActions";
import Swal from "sweetalert2";

export default function AddPostPage() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { categories, loading: loadingCategory } = useSelector((state) => state.categories);
	const { loading: loadingPost } = useSelector((state) => state.posts);
	const [error, setError] = useState(false);
	const [newPost, setNewPost] = useState({
		title: "",
		content: "",
		imgUrl: "",
		categoryId: "",
	});
	const [newTags, setNewTags] = useState([
		{
			name: "",
		},
	]);

	const addInputTag = (e) => {
		e.preventDefault();

		setNewTags([
			...newTags,
			{
				name: "",
			},
		]);
	};

	const removeInputTag = (e, index) => {
		e.preventDefault();

		const rows = [...newTags];
		rows.splice(index, 1);
		setNewTags(rows);
	};

	useEffect(() => {
		dispatch(fetchCategories())
			.catch((err) => {
				setError(true);
			})
			.finally(() => {
				loadingSetCategory(false);
			});
	}, []);

	const changeInputNewPost = (e) => {
		const { name, value } = e.target;
		setNewPost({
			...newPost,
			[name]: value,
		});
	};

	const handleInputTag = (index, e) => {
		const { name, value } = e.target;
		const list = [...newTags];
		list[index][name] = value;
		setNewTags(list);
	};

	const submitHandler = (e) => {
		e.preventDefault();

		dispatch(addPost(newPost, newTags))
			.then(() => {
				Swal.fire({
					position: "top-end",
					icon: "success",
					title: "successfully added new post",
					showConfirmButton: false,
					timer: 1000,
				});
				navigate("/");
			})
			.catch((err) => {
				return Swal.fire({
					icon: "error",
					title: "Error",
					text: err,
				});
			})
			.finally(() => {
				dispatch(loadingSetPost(false));
			});
	};

	return (
		<>
			{loadingCategory || loadingPost ? (
				<LoadingComponent />
			) : (
				<div className="container">
					<h2 className="mb-3">Create News</h2>
					<form>
						<div className="mb-3">
							<label className="form-label">Title</label>
							<input
								type="text"
								name="title"
								className="form-control"
								value={newPost.title}
								onChange={changeInputNewPost}
								placeholder="enter title here"
							/>
						</div>
						<div className="mb-3">
							<label className="form-label">Content</label>
							<textarea
								name="content"
								className="form-control"
								value={newPost.content}
								onChange={changeInputNewPost}
								placeholder="enter content here"
							/>
						</div>
						<div className="mb-3">
							<label className="form-label">Image Url</label>
							<input
								type="text"
								name="imgUrl"
								className="form-control"
								value={newPost.imgUrl}
								onChange={changeInputNewPost}
								placeholder="enter image Url here"
							/>
						</div>
						<div className="mb-3">
							<label className="form-label">Category</label>
							<select
								name="categoryId"
								value={newPost.categoryId}
								onChange={changeInputNewPost}
								className="form-select">
								<option value={""} disabled>
									Select category
								</option>
								{error && <h3>error</h3>}
								{!loadingCategory &&
									!error &&
									categories.map((category) => (
										<option value={category.id} key={category.id}>
											{category.name}
										</option>
									))}
							</select>
						</div>
						<label className="form-label">Tags</label>
						{newTags.map((data, index) => {
							const { name } = data;
							return (
								<div key={index}>
									<div className="mb-2 d-flex">
										<input
											type="text"
											name="name"
											className="form-control"
											value={name}
											placeholder="tag"
											onChange={(e) => handleInputTag(index, e)}
										/>
										{newTags.length !== 1 ? (
											<button
												className="btn btn-outline-danger ms-3"
												onClick={(e) => removeInputTag(e, index)}>
												Remove
											</button>
										) : null}
									</div>
								</div>
							);
						})}
						<div className="mt-3 d-flex justify-content-between">
							<div>
								<button onClick={addInputTag} className="btn btn-success">
									Add Tag
								</button>
							</div>
							<div>
								<button onClick={submitHandler} className="btn btn-primary">
									Share
								</button>
								<button onClick={() => navigate("/")} className="btn btn-danger ms-2">
									Cancel
								</button>
							</div>
						</div>
					</form>
				</div>
			)}
		</>
	);
}
